import axios from 'axios';
import config from './ApiforContext'
const token = localStorage.getItem("token");
export default axios.create({
  baseURL: config.apiUrl,
  headers: {"Authorization": "Bearer " + token?.replace('"','').replace('"','').toString()}
  });
